
export const root = {
    background: '{surface.card}',
    borderRadius: '{border.radius.md}',
    color: '{text.color}',
    shadow: '{shadow.sm}',
    borderWidth: '1px',
    borderColor: '{surface.border}'
};

export const body = {
    padding: '1rem',
    gap: '0.75rem'
};

export const caption = {
    gap: '0.5rem'
};

export const title = {
    fontSize: '1.25rem',
    fontWeight: '500'
};

export const subtitle = {
    color: '{text.secondary.color}'
};

export const header = {
    padding: '1rem',
    borderBottom: '1px solid {surface.border}'
};

export const footer = {
    padding: '1rem',
    borderTop: '1px solid {surface.border}'
};

export default {
    root,
    body,
    caption,
    title,
    subtitle,
    header,
    footer
};
